import React from "react";
import { useDispatch } from "react-redux";
import { ESIGN_DOCUMENT_TYPE } from "../../../constants/commonConstants";
import cx from "classnames";
import Wrapper from "./esignPdfNavigation.styles";
import { BallNumber } from "../components/ballNumber";
import actions from "@redux/esign/actions";

const EsignPdfNavigation = ({
  handleDocumentNavigation,
  activeDocumentType,
}) => {
  const contractActive = activeDocumentType.type === ESIGN_DOCUMENT_TYPE.CONTRACT.type;
  const payScheduleActive = activeDocumentType.type === ESIGN_DOCUMENT_TYPE.PAYMENT_SCHEDULE.type;
  const dispatch = useDispatch();

  return (
    <Wrapper>
      <div
        onClick={() => {
          dispatch(actions.currentEsignPageIndex(1));
          handleDocumentNavigation(ESIGN_DOCUMENT_TYPE.CONTRACT);
        }}
        className={cx("tab-group", { active: contractActive })}
      >
        <BallNumber active={contractActive} questionNumber={1} />
        <p>Loan Contract</p>
      </div>
      <div
        onClick={() => {
          dispatch(actions.currentEsignPageIndex(2));
          handleDocumentNavigation(ESIGN_DOCUMENT_TYPE.PAYMENT_SCHEDULE);
        }}
        className={cx("tab-group", { active: payScheduleActive })}
      >
        <BallNumber active={payScheduleActive} questionNumber={2} />
        <p>Repayment Schedule</p>
      </div>
    </Wrapper>
  );
};

export default EsignPdfNavigation;
